import { Component, ReactNode } from 'react';
import { NoAccess } from 'shared/emptyContent';

export interface ErrorBoundaryProps{
  children: ReactNode;
  locationKey: string;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps: ErrorBoundaryProps) {
    if (prevProps.locationKey !== this.props.locationKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return <NoAccess />;
    }

    const { children } = this.props;
    return children;
  }
}

export default ErrorBoundary;
